import { render } from 'preact'
import { App } from '~/App'
import { RecoveryPage } from '~/pages/recovery/RecoveryPage'
import { startUpdateWatch } from '~/services/updateService'
import { type BootResult, bootDatabase } from '~/storage/boot'
import { requestPersistence } from '~/storage/quota'
import '~/styles/base.css'

/*
 * Boot order (D-028):
 *   database preflight and migration gate → mount → service-worker registration
 *
 * Registration happens last and never gates the UI: an app that cannot register
 * a service worker is not installable, but is otherwise fully functional.
 */

const root = document.getElementById('app')

if (!root) {
  throw new Error('Project Sola: mount point #app was not found in index.html')
}

async function start(mountPoint: HTMLElement): Promise<void> {
  const result: BootResult = await bootDatabase()

  if (result.status !== 'ready') {
    render(<RecoveryPage result={result} onRetry={() => window.location.reload()} />, mountPoint)
    return
  }

  // Ask for persistent storage once the database is usable. Feature-detected,
  // and a refusal changes nothing — persistence is requested, never assumed
  // (D-033).
  void requestPersistence()

  render(<App db={result.db} />, mountPoint)

  /* The service worker is only emitted by a production build, so there is
     nothing to register against a dev server. Registration is deliberately
     after render: precaching must never delay first paint. */
  if (import.meta.env.PROD) startUpdateWatch()
}

void start(root)
